"use strict";

var _classCallCheck = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var MetaformSectionComponent_1 = require("./MetaformSectionComponent");
/**
 * Component for metaform
 */


var MetaformComponent =
/*#__PURE__*/
function (_react_1$default$Comp) {
  _inherits(MetaformComponent, _react_1$default$Comp);

  /**
   * Constructor
   *
   * @param props component props
   */
  function MetaformComponent(props) {
    var _this;

    _classCallCheck(this, MetaformComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MetaformComponent).call(this, props));

    _this.renderTitle = function () {
      if (!_this.props.form.title) {
        return null;
      }

      return react_1.default.createElement("h1", null, " ", _this.props.form.title, "\xA0");
    };
    /**
     * Returns unique id
     *
     * @returns unique id
     */


    _this.getUniqueId = function () {
      return Math.random().toString(36).substr(2);
    };

    _this.state = {
      metaformId: "metaform-" + (_this.props.form.id ? "".concat(_this.props.form.id, "-") : "") + _this.getUniqueId()
    };
    return _this;
  }
  /**
   * Component render method
   */


  _createClass(MetaformComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var sections = this.props.form.sections || [];
      return react_1.default.createElement("div", {
        className: "metaform"
      }, this.renderTitle(), sections.map(function (section, i) {
        var sectionId = "section-".concat(i);
        return react_1.default.createElement(MetaformSectionComponent_1.MetaformSectionComponent, {
          key: "".concat(_this2.state.metaformId, "-").concat(sectionId),
          renderIcon: _this2.props.renderIcon,
          getFieldValue: _this2.props.getFieldValue,
          setFieldValue: _this2.props.setFieldValue,
          metaformId: _this2.state.metaformId,
          sectionId: sectionId,
          formReadOnly: _this2.props.formReadOnly,
          section: section,
          onSubmit: _this2.props.onSubmit
        });
      }));
    }
  }]);

  return MetaformComponent;
}(react_1.default.Component);

exports.MetaformComponent = MetaformComponent;